import { FetchStatus } from 'types/api';
import { DocumentCategory } from 'types/api';
import { useState } from 'react';
import { isAxiosError } from 'axios';
import { commonApi } from 'api';

export const useFetchFilters = () => {
  const [categories, setCategories] = useState<DocumentCategory[]>([]);
  const [departments, setDepartments] = useState<
    Omit<DocumentCategory, 'created_at'>[]
  >([]);
  const [status, setStatus] = useState<FetchStatus>('idle');
  const [error, setError] = useState<string | null>(null);

  const fetchCategories = async () => {
    setStatus('loading');
    try {
      const [categoriesResponse, departmentsResponse] = await Promise.all([
        commonApi.getCategories(),
        commonApi.getDepartments(),
      ]);
      setCategories(categoriesResponse);
      setDepartments(departmentsResponse);

      setStatus('success');
    } catch (error) {
      if (isAxiosError(error)) {
        setError(error.response?.data.message);
      } else {
        setError(JSON.stringify(error));
      }
      setStatus('failed');
    }
  };

  return { departments, categories, status, error, fetchCategories };
};
